import { render, staticRenderFns } from "./EducationLevelRanges.vue?vue&type=template&id=54bfff42&scoped=true"
import script from "./EducationLevelRanges.vue?vue&type=script&lang=js"
export * from "./EducationLevelRanges.vue?vue&type=script&lang=js"
import style0 from "./EducationLevelRanges.vue?vue&type=style&index=0&id=54bfff42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfff42",
  null
  
)

export default component.exports